exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  /* border: 0 solid #e1e1e1;\n  border-bottom-width: 1px;\n  display: block;\n  height: 48px;\n  padding: 0 16px; */\n\n  height: 55px;\n  background-color: #fff;\n  border-bottom: 1px solid #c2cfd6;\n}\n\nnav a {\n  color: #8f8f8f;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 48px;\n  margin-right: 20px;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\nnav a.router-link-active {\n  color: #106cc8;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/shared/navbar/navbar.component.css
// module id = ../../../../../src/app/shared/navbar/navbar.component.css
// module chunks = main